module.exports = __webpack_public_path__ + "img/agent-results.8080b4c7.webp";